<div class="container-fluid">
    <!-- Close button (cross) in the top-right corner -->
    <button class="close-btn" (click)="onClose()">
      <i class="feather icon-x"></i> <!-- Cross icon -->
    </button>
      <div class="row justify-content-center ">
  
          <div>
              <div>
                  <div class="card-body">
                      <div class="mb-4 d-md-flex align-items-center justify-content-center">
                          <div>
                              <h4>Master</h4>
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-md-12">
  
                              <form (ngSubmit)="onSubmit()">
                                  <div class="row">
                                      <div class="col form-group mb-3">
                                        <label for="category"  class="form-label">Category</label>
                                        <div class="input-group">
                                            <input type="text" id="category" [(ngModel)]="category" name="category" class="form-control" required />
                                          </div>
                                      </div>
                                      <div class="col form-group mb-3">
                                          <label for="subcategory" class="form-label">Subcategory</label>
                                          <div class="input-group">
                                          <input type="text" id="subcategory" [(ngModel)]="subcategory" name="subcategory" class="form-control" required />
                                          </div>
                                      </div>
                                  </div>
                                  <div class="text-end">
                                      <button type="submit" class="btn btn-outline-dark">
                                          Submit</button>
                                  </div>
                              </form>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>

  